import {NdfTaxe} from "./ndf-taxe";

/**
 * Modèle pour une saisie de la taxe pour un ensemble de taux
 */
export class SaisieTaxe {
    /** Liste des saisies pour un taux */
    listeTaxes: NdfTaxe[];

    /** Indicateur de modification des saisies */
    isUpdateMontants: boolean;

    /**
     * Constructeur
     */
    constructor() {
        this.listeTaxes = [];
        this.isUpdateMontants = false;
    }
}